// Tipos de relación laboral de un usuario retail, como los muestran los selects.
import { EmploymentTypeEnum } from '@fiado/type-kit/bin/retailOrg/enums/EmploymentTypeEnum';
import type { SelectOption } from '@/kit';

export const EMPLOYMENT_OPTIONS: SelectOption[] = [
    { value: EmploymentTypeEnum.EMPLOYEE, label: 'Empleado' },
    { value: EmploymentTypeEnum.CONTRACTOR, label: 'Contratista' },
    { value: EmploymentTypeEnum.FRANCHISEE_STAFF, label: 'Personal de franquicia' },
];
